import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Divider, Input, Button, Space, Select, message } from 'antd';
import { DatePicker } from '@components/TimePicker';
import {
  CalendarOutlined,
  UserOutlined,
  MobileOutlined,
  MailOutlined,
  HomeOutlined,
  GlobalOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import UploadAvatarCV from './UploadAvatar';
import styles from './CVInfoForm.module.scss';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const avatar_default = '/images/avatar_cv_default.jpg';

export const genderType = {
  MALE: { key: 'MALE', value: 'Nam' },
  FEMALE: { key: 'FEMALE', value: 'Nữ' },
  OTHER: { key: 'OTHER', value: 'Khác' },
};

const formatDate = 'DD/MM/YYYY';
const formatMonth = 'DD/MM/YYYY';

const CVInfoForm = ({ onSave, initialValues, onCancel }) => {
  const [form] = Form.useForm();
  const [avatarUrl, setAvatarUrl] = useState();

  const handleOnSave = () => {
    form.validateFields().then(async (values) => {
      if (!avatarUrl) {
        return message.error('Vui lòng thêm ảnh đại diện!');
      };

      let education = JSON.stringify(values.education);
      if (!values.education.length) {
        education = JSON.stringify([values.education]);
      };

      let experience = JSON.stringify(values.experience);
      if (!values.experience.length) {
        experience = JSON.stringify([values.experience]);
      };

      const dataRequest = {
        ...values,
        id: values.id || initialValues.id,
        avatarUrl: avatarUrl,
        education: education,
        experience: experience,
      };

      if (onSave) onSave({...initialValues, ...dataRequest});
    });
  };

  useEffect(() => {
    if (form && initialValues) {
      let education = initialValues?.education ? JSON.parse(initialValues.education) : null;
      education = education?.map((edu) => {
        return {
          ...edu,
          rangeTime: [dayjs(edu.rangeTime[0]), dayjs(edu.rangeTime[1])],
        };
      });

      let experience = initialValues?.experience ? JSON.parse(initialValues.experience) : null;
      experience = experience?.map((exp) => {
        return {
          ...exp,
          rangeTime: [dayjs(exp.rangeTime[0]), dayjs(exp.rangeTime[1])],
        };
      });

      const initData = {
        ...initialValues,
        birthDate: initialValues?.birthDate ? dayjs(initialValues.birthDate) : null,
        education,
        experience,
      };

      form.setFieldsValue(initData);
      if (initialValues.avatarUrl) setAvatarUrl(initialValues.avatarUrl);
    }
  }, [initialValues]);

  return (
    <Form
      form={form}
      name="cv-info-form"
      className={styles['vn-rb-cv-info-form']}
      onFinish={handleOnSave}
    >
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>

      <Row gutter={24}>
        <Col xs={24} sm={24} md={8} className={styles['personal-info']}>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: 'Nhập tên.',
              },
            ]}
          >
            <Input
              bordered={false}
              placeholder="Warren Nguyễn"
              style={{ textAlign: 'center', fontSize: 30, fontWeight: 'bold', color: '#FF9818' }}
            />
          </Form.Item>

          <Form.Item
            name="profession"
            rules={[
              {
                required: true,
                message: 'Nhập chuyên môn',
              },
            ]}
            className={styles.careerInput}
          >
            <Input.TextArea 
              autoSize
              bordered={false}
              placeholder="IB, Master IB"
              style={{ textAlign: 'center', fontWeight: 'bold' }}
            />
          </Form.Item>

          <div className={styles['avatar-wrapper']}>
            <UploadAvatarCV
              currentAvatar={avatarUrl || avatar_default}
              setImageUrl={setAvatarUrl}
            />
          </div>

          <div className="contact-info">
            <p className={styles['title']}>Thông tin liên hệ</p>
            <Form.Item
              name="birthDate"
              rules={[
                {
                  required: true,
                  message: 'Nhập ngày tháng năm sinh.',
                },
              ]}
            >
              <DatePicker
                format={formatDate}
                style={{ width: '100%' }}
                placeholder='19/05/1992'
                suffixIcon={<CalendarOutlined style={{ color: '#FF9818' }} />}
                bordered={false}
              />
            </Form.Item>

            <Form.Item
              name="gender"
              rules={[
                {
                  required: true,
                  message: 'Nhập giới tính.',
                },
              ]}
            >
              <Select
                bordered={false}
                placeholder="Giới tính"
                suffixIcon={<UserOutlined style={{ color: '#FF9818' }} />}
              >
                {Object.values(genderType).map((gender) => (
                  <Select.Option key={gender.key} value={gender.key}>
                    {gender.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  message: 'Nhập số điện thoại liên hệ.',
                },
              ]}
            >
              <Input
                type="number"
                bordered={false}
                placeholder="Số điện thoại"
                prefix={<MobileOutlined style={{ color: '#FF9818' }} />}
                style={{ width: '100%' }}
              />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Email không đúng!',
                },
              ]}
            >
              <Input
                bordered={false}
                placeholder="Email"
                prefix={<MailOutlined style={{ color: '#FF9818' }} />}
              />
            </Form.Item>

            <Form.Item
              name="address"
              rules={[
                {
                  required: true,
                  message: 'Nhập địa chỉ.',
                },
              ]}
            >
              <Input
                bordered={false}
                placeholder="Số 10, đường số 10, HCM"
                prefix={<HomeOutlined style={{ color: '#FF9818' }} />}
              />
            </Form.Item>

            <Form.Item name="personalLink">
              <Input
                bordered={false}
                placeholder="https://fb.com/topcv.vn"
                prefix={<GlobalOutlined style={{ color: '#FF9818' }} />}
              />
            </Form.Item>
          </div>

          <Divider className={styles['divider']} />
        </Col>

        <Col xs={24} sm={24} md={16}>
          <p className={styles['title']}>Mục tiêu nghề nghiệp</p>
          <Form.Item
            name="careerGoals"
            rules={[
              {
                required: true,
                message: 'Nhập mục tiêu nghề nghiệp.',
              },
            ]}
          >
            <Input.TextArea 
              bordered={false} 
              autoSize 
              placeholder='- Muốn trở thành IB chuyên nghiệp, phát triển khách hàng cho các Broker tốt trên thế giới tại VN
              - Phát triển kỹ năng Phân tích và trading để mang lại giá trị thực sự chất lượng cho các khách hàng của mình'
            />
          </Form.Item>
          <Divider className={styles['divider']} />

          <p className={styles['title']}>Học vấn</p>
          <Form.List
            name="education"
            rules={[
              {
                validator: async (_, names) => {
                  if (!names || names.length < 1) {
                    return Promise.reject(new Error('Vui lòng thêm học vấn.'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {!initialValues?.education &&
                  <Space key='first'>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name={['shoolName']}
                          fieldKey={['shoolName']}
                          rules={[{ required: true, message: 'Nhập tên trường.' }]}
                        >
                          <Input
                            placeholder="Đại học Kinh tế HCM"
                            bordered={false}
                            style={{ fontWeight: 'bold' }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name={['rangeTime']}
                          fieldKey={['rangeTime']}
                          rules={[{ required: true, message: 'Nhập thời gian học.' }]}
                        >
                          <RangePicker
                            style={{ width: '100%' }}
                            picker="month"
                            bordered={false}
                            format={formatMonth}
                            placeholder={['17/10/2010', '17/05/2014']}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name={['description']}
                          fieldKey={['description']}
                          rules={[{ required: true, message: 'Nhập mô tả.' }]}
                        >
                          <Input.TextArea 
                            placeholder="Mô tả" 
                            bordered={false} 
                            autoSize 
                            placeholder="Tài chính ngân hàng Tốt nghiệp loại Khá"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Space>
                }
                {fields.map((key, name, fieldKey, ...restField) => (
                  <Space key={key}>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          name={[name, 'shoolName']}
                          fieldKey={[fieldKey, 'shoolName']}
                          rules={[{ required: true, message: 'Nhập tên trường.' }]}
                        >
                          <Input
                            placeholder="Đại học Kinh tế HCM"
                            bordered={false}
                            style={{ fontWeight: 'bold' }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          name={[name, 'rangeTime']}
                          fieldKey={[fieldKey, 'rangeTime']}
                          rules={[{ required: true, message: 'Nhập thời gian học.' }]}
                        >
                          <RangePicker
                            style={{ width: '100%' }}
                            picker="month"
                            bordered={false}
                            format={formatMonth}
                            placeholder={['17/10/2010', '17/05/2014']}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'description']}
                          fieldKey={[fieldKey, 'description']}
                          rules={[{ required: true, message: 'Nhập mô tả.' }]}
                        >
                          <Input.TextArea 
                            placeholder="Mô tả" 
                            bordered={false} 
                            autoSize 
                            placeholder="Tài chính ngân hàng Tốt nghiệp loại Khá"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}

                <Button
                  type="dashed"
                  onClick={() => {
                    add();
                  }}
                  icon={<PlusOutlined />}
                >
                  Thêm trường
                </Button>
                <Form.ErrorList errors={errors} />
              </>
            )}
          </Form.List>
          <Divider className={styles['divider']} />

          <p className={styles['title']}> Kinh nghiệm làm việc</p>
          <Form.List
            name="experience"
            rules={[
              {
                validator: async (_, names) => {
                  if (!names || names.length < 1) {
                    return Promise.reject(new Error('Vui lòng thêm công ty.'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
              {!initialValues?.experience &&
                <Space key='first'>
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name={['title']}
                        fieldKey={['title']}
                        rules={[{ required: true, message: 'Nhập chức danh.' }]}
                      >
                        <Input
                          placeholder="Chuyên viên KHCN"
                          bordered={false}
                          style={{ fontWeight: 'bold' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name={['rangeTime']}
                        fieldKey={['rangeTime']}
                        rules={[{ required: true, message: 'Nhập thời gian làm việc.' }]}
                      >
                        <RangePicker
                          style={{ width: '100%' }}
                          picker="month"
                          bordered={false}
                          format={formatMonth}
                          placeholder={['17/06/2014', '17/02/2015']}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={['companyName']}
                        fieldKey={['companyName']}
                        rules={[{ required: true, message: 'Nhập tên công ty.' }]}
                      >
                        <Input
                          placeholder="Ngân hàng XYZ"
                          bordered={false}
                          style={{ color: '#bbbbbb' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={['description']}
                        fieldKey={['description']}
                        rules={[{ required: true, message: 'Nhập mô tả.' }]}
                      >
                        <Input.TextArea 
                          placeholder="Mô tả" 
                          bordered={false} 
                          autoSize 
                          placeholder='- Tìm kiếm KH có nhu cầu vay, gửi TK
                          - Tìm kiếm KH có nhu cầu trao đổi ngoại tệ để đi định cư, chuyển nhận tiền Kiều hối ...'
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Space>
                }
                {fields.map((key, name, fieldKey, ...restField) => (
                  <Space key={key}>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          name={[name, 'title']}
                          fieldKey={[fieldKey, 'title']}
                          rules={[{ required: true, message: 'Nhập chức danh.' }]}
                        >
                          <Input
                            placeholder="Chuyên viên KHCN"
                            bordered={false}
                            style={{ fontWeight: 'bold' }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          name={[name, 'rangeTime']}
                          fieldKey={[fieldKey, 'rangeTime']}
                          rules={[{ required: true, message: 'Nhập thời gian làm việc.' }]}
                        >
                          <RangePicker
                            style={{ width: '100%' }}
                            picker="month"
                            bordered={false}
                            format={formatMonth}
                            placeholder={['17/06/2014', '17/02/2015']}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'companyName']}
                          fieldKey={[fieldKey, 'companyName']}
                          rules={[{ required: true, message: 'Nhập tên công ty.' }]}
                        >
                          <Input
                            placeholder="Ngân hàng XYZ"
                            bordered={false}
                            style={{ color: '#bbbbbb' }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'description']}
                          fieldKey={[fieldKey, 'description']}
                          rules={[{ required: true, message: 'Nhập mô tả.' }]}
                        >
                          <Input.TextArea 
                            placeholder="Mô tả" 
                            bordered={false} 
                            autoSize 
                            placeholder='- Tìm kiếm KH có nhu cầu vay, gửi TK
                            - Tìm kiếm KH có nhu cầu trao đổi ngoại tệ để đi định cư, chuyển nhận tiền Kiều hối ...'
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}

                <Button
                  type="dashed"
                  onClick={() => {
                    add();
                  }}
                  icon={<PlusOutlined />}
                >
                  Thêm công ty
                </Button>
                <Form.ErrorList errors={errors} />
              </>
            )}
          </Form.List>
          <Divider className={styles['divider']} />

          <p className={styles['title']}>Chứng chỉ</p>
          <Form.Item
            name="certificate"
            rules={[
              {
                required: true,
                message: 'Nhập chứng chỉ.',
              },
            ]}
          >
            <Input.TextArea 
              bordered={false} 
              autoSize 
              placeholder='2013 : TOEIC 750
              2014 : CMT
              2015 : CFA level 1'
            />
          </Form.Item>
          <Divider className={styles['divider']} />
        </Col>
      </Row>

      <Form.Item style={{textAlign: "end"}} className={styles.footerButtons}>
        <Button type="primary" htmlType="submit" className={styles['btnSave']}>
          Lưu
        </Button>

        <Button type="dashed" className={styles['btnCancel']} onClick={onCancel}>
          Đóng
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CVInfoForm;
